import { render, staticRenderFns } from "./CollegeList.vue?vue&type=template&id=672104c6&scoped=true"
import script from "./CollegeList.vue?vue&type=script&lang=ts"
export * from "./CollegeList.vue?vue&type=script&lang=ts"
import style0 from "./CollegeList.vue?vue&type=style&index=0&id=672104c6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672104c6",
  null
  
)

export default component.exports